import createLucideIcon from '../createLucideIcon';
import type { LucideIconNode, LucideIconData } from '../types';

export const __iconData: LucideIconData = {
  name: 'germ',
  size: 24,
  node: [
    ['path', { d: 'm11 2 .925 1.848', key: 'geewpq' }],
    ['path', { d: 'M13 15h.01', key: 'igtdqu' }],
    ['path', { d: 'm16 21-1-2.472', key: '197l0j' }],
    ['path', { d: 'm19 2-1 1.804', key: 'qavonm' }],
    ['path', { d: 'm2 19 2.746-1.373', key: '1mv7mx' }],
    ['path', { d: 'm22 16-2.474-2.13', key: '1hzzot' }],
    ['path', { d: 'm22 5-1.804 1', key: '8v36m5' }],
    ['path', { d: 'm3 10 2 2', key: '1n5c32' }],
    ['path', { d: 'M9 16h.01', key: '1zau5q' }],
    ['path', { d: 'M9 20v2', key: 'i2bqo8' }],
    [
      'path',
      {
        d: 'M9.33 7.035c-.51 1.478-1.786 2.93-3.09 3.794A5 5 0 009 20a12.1 12.1 0 0011.902-9.916A6 6 0 009.33 7.035',
        key: 'lfugof',
      },
    ],
    ['circle', { cx: '15', cy: '9', r: '2', key: '14ricq' }],
  ],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name Germ
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMTEgMiAuOTI1IDEuODQ4IiAvPgogIDxwYXRoIGQ9Ik0xMyAxNWguMDEiIC8+CiAgPHBhdGggZD0ibTE2IDIxLTEtMi40NzIiIC8+CiAgPHBhdGggZD0ibTE5IDItMSAxLjgwNCIgLz4KICA8cGF0aCBkPSJtMiAxOSAyLjc0Ni0xLjM3MyIgLz4KICA8cGF0aCBkPSJtMjIgMTYtMi40NzQtMi4xMyIgLz4KICA8cGF0aCBkPSJtMjIgNS0xLjgwNCAxIiAvPgogIDxwYXRoIGQ9Im0zIDEwIDIgMiIgLz4KICA8cGF0aCBkPSJNOSAxNmguMDEiIC8+CiAgPHBhdGggZD0iTTkgMjB2MiIgLz4KICA8cGF0aCBkPSJNOS4zMyA3LjAzNWMtLjUxIDEuNDc4LTEuNzg2IDIuOTMtMy4wOSAzLjc5NEE1IDUgMCAwMDkgMjBhMTIuMSAxMi4xIDAgMDAxMS45MDItOS45MTZBNiA2IDAgMDA5LjMzIDcuMDM1IiAvPgogIDxjaXJjbGUgY3g9IjE1IiBjeT0iOSIgcj0iMiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/germ
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Germ = createLucideIcon(__iconData);

export default Germ;
